import { object, ref, string } from "yup"
import { MAX_EMAIL_LENGTH } from "./customer"
import { emailSchema } from "./email"
import { buildSchema } from "./util/build-schema"

const minPasswordLength = 12

const schema = object({
  email: emailSchema.max(MAX_EMAIL_LENGTH).required(),
  password: string().min(minPasswordLength).required(),
  passwordConfirmation: string()
    .nullable()
    .oneOf([ref("password"), null], "yup.user.passwordConfirmation.mustMatch"),
  username: string()
    .required()
    .matches(/^[a-zA-Z0-9]+$/, {
      message: "Must contain only letters and numbers",
      excludeEmptyString: true,
    }),
})

export const userSchema = buildSchema("User", schema)
